require('static')
